import { useEffect, useState } from 'react';

export const useSubmenuPosition = (
  containerRef: React.RefObject<HTMLElement>,
  deps: any[] = []
) => {
  const [subMenuPosition, setSubMenuPosition] = useState<'right' | 'left'>(
    'right'
  );
  // Check if submenu will be displayed on the left or right side of the parent menu
  useEffect(() => {
    if (containerRef.current) {
      const { left, right } = containerRef.current?.getBoundingClientRect();
      const { width } = containerRef.current?.getBoundingClientRect();
      const { innerWidth } = window;

      if (right > innerWidth - width) {
        setSubMenuPosition('left');
      } else {
        setSubMenuPosition('right');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps]);

  return subMenuPosition;
};
